module.exports = __webpack_public_path__ + "static/media/two-trees.f3f1fafb.png";